module.exports = __webpack_public_path__ + "static/media/Avatar.ad9c25d7.png";